(function ($) {
    function checkCookieBanner() {
        setTimeout(function () {
            var dc = document.cookie;
            var acceptedCookies =
                dc.indexOf('OptanonAlertBoxClosed') !== null &&
                dc.indexOf('OptanonAlertBoxClosed') > -1;
            if (!acceptedCookies) {
                acceptedCookies =
                    $('.optanon-alert-box-wrapper').is(':visible') !== true;
            }

            if (acceptedCookies === true) {
                $('.om-footer-forms').removeAttr('style');
                $('header').css({ position: 'relative', height: 'auto' });
                $('.sub-menu').css({ position: 'absolute' });
                $('#js-om-webb-content').removeAttr('style');
                $('body').removeAttr('style');
            } else {
                var matrix = new WebKitCSSMatrix($('body').css('transform'));
                $('.om-footer-forms').css({
                    transform: 'translateY(-' + matrix.m42 + 'px)',
                });
                $('body').css({
                    position: 'fixed',
                    width: '100%',
                    height: '100%',
                    padding: '0',
                });
                $('#js-om-webb-content').css({ height: '100%', overflow: ' auto' });
                $('header').css({ position: 'relative' });
                $('.sub-menu').css({ position: '' });
                checkCookieBanner();
            }
        }, 1000);
    }
    checkCookieBanner();

    $('.language > a').on('click', function (e) {
        if ($('.language').hasClass('animating')) {
            return;
        }

        $('.language').toggleClass('open');
        $('.language').addClass('animating');

        if ($('.language').hasClass('open')) {
            $('.language-selector-container').transition(
                { height: 'auto', 'padding-top': '1rem' },
                200,
                'in-out',
                function () {
                    $('.language').removeClass('animating');
                }
            );
            $('.language-selector').addClass('position-fixed-lang');

        } else {
            $('.language-selector-container').transition(
                { height: 0, 'padding-top': 0 },
                200,
                'in-out',
                function () {
                    $('.language').removeClass('animating');
                }
            );
            $('.language-selector').removeClass('position-fixed-lang');

        }
    });

    if ($('#add_email').length > 0) {
        $('#add_email').hide();
    }
    if ($('.add_email').length > 0) {
        $('.add_email').hide();
    }

    $('#FaqCategorySelect').on('change', function () {
        // alert("test");
        var snu = '.' + $(this).val();
        $('.faq.accordion-item').not(snu).hide();
        //$(snu).first().addClass("open");
        $(snu).show();
    });

    var ddsel2 = $('#supportSelect2');

    ddsel2.on('change', function () {
        var selectedOption = $(this).find(':selected');

        if (selectedOption.data('show-address-fields') === 'True') {
            $('.dynamic-address-fields').show();
        } else {
            $('.dynamic-address-fields').hide();
        }

        if (selectedOption.data('show-serial-number') === 'True') {
            $('.dynamic-serialnumber-fields').show();
            $('#serialnumber').attr('required', '');
        } else {
            $('.dynamic-serialnumber-fields').hide();
            $('#serialnumber').removeAttr('required');
        }
    });
    ddsel2.select2();
    var ddsel1 = $('#supportSelect1');
    ddsel1.select2().on('change', function () {
        var sel1self = $(this);
        if (sel1self.data('options') == undefined) {
            /*Taking an array of all options-2 and kind of embedding it on the select1*/
            sel1self.data('options', $('#supportSelect2 option').clone());
        }
        var id = sel1self.val();
        var options = sel1self.data('options').filter('[data-parentid=' + id + ']');
        if (ddsel2.data('select2')) {
            ddsel2.select2('destroy');
        }
        ddsel2.html(options);
        //ddsel2.val(options);
        if (ddsel1.valid() === true) {
            ddsel2.prop('disabled', false);
        } else {
            ddsel2.prop('disabled', true);
        }
        ddsel2.select2();

        $('.dynamic-address-fields').hide();
        $('.dynamic-serialnumber-fields').hide();
        $('#serialnumber').removeAttr('required');
    });

    $('#submitSupportErrand').on('click', function (e) {
        e.preventDefault();
        $.validator.messages.required = '';

        $('#supportForm').validate();

        if ($('#supportForm').valid()) {
            var stringArray = [];
            stringArray[0] = $('#supportSelect1').text();
            stringArray[1] = $('#select2-supportSelect2-container').attr('title');
            stringArray[2] = $('#select2-supportSelect2-container').text();
            var postData = { values: stringArray };
            $('#supportForm').append(postData);
            $('#supportForm').submit();
        } else {
            $('#supporterror').show();
        }
    });

    // When clicking the menu button
    $('.new-c-ham-menu').on('click', function (e) {
        // $(this).toggleClass('open');
        // Let the previous animation finish

        if ($('.new-mobile-menu').hasClass('animating')) {
            return;
        }

        // Set animating
        $('.new-mobile-menu').addClass('animating');

        // Toggle active class on the button and on the menu itself
        $(this).toggleClass('active');
        $('.new-mobile-menu').toggleClass('active');

        if ($('.new-mobile-menu').hasClass('active')) {
            setHeaderColorToWhite();
            $('html').addClass('new-mobile-menu-open');
            // If the menu is active, animate it to open state
            $('.new-mobile-menu').transition(
                { height: 'auto' },
                200,
                'in-out',
                function () {
                    $('.new-mobile-menu').removeClass('animating');
                }
            );
        } else {
            $('html').removeClass('new-mobile-menu-open');
            // Animate it to closed state
            $('.new-mobile-menu').transition({ height: 0 }, 200, 'in-out', function () {
                $('.new-mobile-menu').removeClass('animating');
            });
            setInitialHeaderColor();
        }
    });

    // When clicking the arrow on a menu item that has a <ul> child
    $('.new-mobile-menu li')
        .has('ul')
        .find('.arrow')
        .on('click', function () {
            var $this = $(this).parents('li');

            // Let previous animations finish
            if ($this.hasClass('animating')) {
                return;
            }

            // Set animating
            $this.addClass('animating');

            // Toggle the active class on the item
            $this.toggleClass('active');

            var self = $this;

            if ($this.hasClass('active')) {
                // If the item is active, animate it to open statae
                $this
                    .find('ul')
                    .transition({ height: 'auto' }, 200, 'in-out', function () {
                        self.removeClass('animating');
                    });
            } else {
                // Animate to closed state
                $this.find('ul').transition({ height: 0 }, 200, 'in-out', function () {
                    self.removeClass('animating');
                });
            }
        });

    // When clicking the arrow on a menu item that has a <ul> child
    $('.footer-menu .menu-item')
        .has('ul')
        .find('.arrow')
        .on('click', function () {
            var $this = $(this).parents('.menu-item');

            // Let previous animations finish
            if ($this.hasClass('animating')) {
                return;
            }

            // Set animating
            $this.addClass('animating');

            // Toggle the active class on the item
            $this.toggleClass('active');

            var self = $this;

            if ($this.hasClass('active')) {
                // If the item is active, animate it to open statae
                $this
                    .find('ul')
                    .transition({ height: 'auto' }, 200, 'in-out', function () {
                        self.removeClass('animating');
                    });
            } else {
                // Animate to closed state
                $this.find('ul').transition({ height: 0 }, 200, 'in-out', function () {
                    self.removeClass('animating');
                });
            }
        });

    $(window).on('resize', function () {
        if (map) {
            if (typeof google === 'undefined') {
                return;
            }
            google.maps.event.trigger(map, 'resize');
        }
        var viewportWidth = $(window).width();
        if (viewportWidth > 1199) {
            $('html').removeClass('new-mobile-menu-open');
            $('.new-mobile-menu').removeClass('active').css('height', '0');
            $('.new-c-ham-menu').removeClass('active');
        } else {
            if ($('html').hasClass('search-open')) {
                $('html').removeClass('search-open');
            }
        }
    });

    var lastScroll = 0;
    function scrollFunction(e) {
        // Resize menu on scroll
        var scrollTop = $(document).scrollTop();
        var scrollLimit = 16 * 3.5;

        // if($(document).scrollTop() == 0 ) {
        //     $('.header-info').css({'display': 'block'});
        // }

        // if (scrollTop > lastScroll && scrollTop > scrollLimit) {
        //     // Down
        //     console.log("down")
        //     $('body').addClass('compact');
        //     // $('.header-info a').attr('tabindex', '-1');
        //     $('.header-info').css({'display': 'none'});

        //     lastScroll = scrollTop;
        // }
        // else if (Math.abs(scrollTop - lastScroll) > scrollLimit) {
        //     // Up
        //     console.log("up")
        //     $('body').removeClass('compact');
        //     // $('.header-info a').attr('tabindex', '0');
        //     lastScroll = scrollTop;
        // }

        //  Reveal timeline items as you scroll down

        var bottomOfWindow = scrollTop + $(window).height();
        $('.timeline-block:not(.visible)').each(function (i, item) {
            var block = $(item);
            var blockOffset = block.offset().top;

            if (blockOffset < bottomOfWindow - 200) {
                block.addClass('visible');
            }
        });
    }

    var throttledScrollFunction = throttle(scrollFunction, 100);
    // $(window).on('scroll', throttledScrollFunction);
    // scrollFunction();
    $(window).scroll(function () {
        throttledScrollFunction();
        stickyOnScroll();
    });

    $('.js-search-button-former-main-menu').on('click', function (e) {
        var inputVal = $('#searchInput').attr('value');
        $('.search-results-cover').fadeIn(200);
        if ($('html').hasClass('search-open')) {
            $('.search-results-cover').fadeOut(200);
            $('html').removeClass('search-open');
            if ($('#searchInput').val()) {
                $('#searchInput').val('');
            }
        } else {
            // if ($('body').scrollTop() > 0) {
            //     $('body').animate({ 'scrollTop': 0 }, 200, function () {
            //         $('.search-results-cover').fadeIn(200);
            //         $('html').addClass('search-open');
            //         $('.menu-search-box input').focus();
            //     });
            // }
            // else {
            $('.search-results-cover').fadeIn(200);
            $('html').addClass('search-open');
            $('.menu-search-box input').focus();
            // }
        }
    });

    $('.js-search-button').on('click', function (e) {
        if ($('html').hasClass('search-open')) {
            //     $('.search-results-cover').fadeOut(200, function () {
            $('html').removeClass('search-open');
            //  });
        } else {
            // if ($('body').scrollTop() > 0) {
            //     $('body').animate({ 'scrollTop': 0 }, 200, function () {
            //         $('.search-results-cover').fadeIn(200);
            //         $('html').addClass('search-open');
            //         $('.menu-search-box input').focus();
            //     });
            // }
            // else {
            // $('.search-results-cover').fadeIn(200);
            $('html').addClass('search-open');
            $('.menu-search-box input').focus();
            // }
        }
    });

    function addFiller() {
        var header = $('#header').outerHeight(true);
        var headerTop = $('.header-top').outerHeight(true);
        var productmenuTop = $('.js-product-menu').outerHeight(true);
        var stickyFiller = $('.filler');
        var formerMenu = $('.js-former-main-menu');
        var headerInfo = $('.header-info').outerHeight(true);

        if ($('.js-product-menu').length) {
            if ($('.header-info').is(':visible')) {
                stickyFiller.css({
                    height: '' + Math.abs(header - headerInfo) + 'px',
                });
            } else if ($('.header-info').css('display') == 'none') {
                stickyFiller.css({
                    height: '' + Math.abs(header) + 'px',
                });
            }
        } else {
            if ($('.header-info').is(':visible')) {
                stickyFiller.css({
                    height: '' + Math.abs(header - headerInfo) + 'px',
                });
            } else if ($('.header-info').css('display') == 'none') {
                stickyFiller.css({
                    height: '' + Math.abs(header) + 'px',
                });
            }
        }
    }

    var header = $('#header');
    var headerPos = header.offset().top;
    var body = $('body');

    function stickyOnScroll() {
        var jsOmWebContent = $('#js-om-webb-content');
        var stickyFiller = $('.filler');
        var windowScrolltop = $(document).scrollTop();
        var joyweekIcon = $('#joyweek-icon-header');

        jsOmWebContent.removeAttr('style');
        if (windowScrolltop > headerPos) {
            body.addClass('sticky-nav');
            $('body').css({ transform: 'none' });
            body.css({ overflow: 'hidden' });
            stickyFiller.removeClass('hide-filler');
            addFiller();
        } else {
            $('.main-menu-right button--contact').removeAttr('style');
            body.removeClass('sticky-nav');
            // body.css({ overflow: 'auto' });
            body.removeAttr('style');
            stickyFiller.addClass('hide-filler');
            stickyFiller.removeAttr('style');
        }
    }

    $('.js-mobile-search-btn').on('click', function (e) {
        $(this).parent().parent().toggleClass('mobile-search-open');
        $(this).parent().parent().find('input').focus();
    });

    $('.timeline-content').each(function (i, element) {
        var $element = $(element);

        var textContent = $element
            .find('.timeline-content-text-content-intro')
            .find('p');

        if (textContent.length > 0) {
            $element.find('.timeline-read-more').show();
        }
    });

    $('.timeline-content-text .timeline-read-more').on('click', function (e) {
        e.preventDefault();
        $('.timeline-content-text-content-main').show();
        //$(this).parent().find('.timeline-content-text-content').css({'max-height': 'none'});
        $(this).hide();
    });

    $('.accordion-header').on('click', function () {
        var parent = $(this).parent();
        var body = parent.find('.accordion-body');

        if (parent.hasClass('no-arrow')) {
            return;
        }

        if (parent.hasClass('open')) {
            body.height(body.height());
            body.transition({ height: 0 }, 200, 'in-out', function () {
                $(this).hide();
                parent.removeClass('open');
            });
        } else {
            body.show().height(0);
            body.transition({ height: 'auto' }, 200, 'in-out');
            parent.addClass('open');
        }
    });

    $('.product-selector').on('click', function (e) {
        $('.product-selector').removeClass('active');
        $(this).addClass('active');

        $('.product-information').removeClass('active');
        $('.product-information[data-id=' + $(this).data('id') + ']').addClass(
            'active'
        );
    });

    $('a.contact-button-block').on('click', function (e) {
        e.preventDefault();
        $('.product-contact-form').fadeIn(200);
        $('html, body').animate(
            {
                scrollTop: $('.product-contact-form').offset().top,
            },
            300
        );
    });

    $('.product-mini-hero a.button').on('click', function (e) {
        e.preventDefault();
        $(this).parents('.content').find('.product-contact-form').fadeIn(200);
    });

    $('.product-mini-hero .close-button').on('click', function (e) {
        e.preventDefault();
        $(this).parents('.content').find('.product-contact-form').fadeOut(200);
    });

    var joyweekIcon = $('#joyweek-icon-header');

    $('.js-mega-menu-dropdown').hover(
        function () {
            $('.c-mega-menu-wrap', this).stop().fadeIn('fast');

            joyweekIcon.children("div").removeClass('joyweek-icon-big');
            joyweekIcon.children("div").addClass('joyweek-icon');
        },
        function () {
            $('.c-mega-menu-wrap', this).stop().fadeOut('fast');
        }
    );

    $('.js-former-main-menu ul').menuAim({
        activate: function (item) {
            //console.log('activate');
            var id = $(item).find('a').attr('data-id');
            var submenu = $('.sub-menu[data-id=' + id + ']');

            submenu.fadeIn(200);
            submenu.css('z-index', '1');
        },
        deactivate: function (item) {
            //console.log('deactivate');
            var id = $(item).find('a').attr('data-id');
            var submenu = $('.sub-menu[data-id=' + id + ']');

            var activeSubmenu = $('.sub-menu.active');

            if (!submenu.is(activeSubmenu)) {
                submenu.fadeOut(200, function () {
                    submenu.css('z-index', '');
                });
            } else {
                submenu.css('z-index', '');
            }
        },
        exit: function () {
            //console.log('exit');
        },
        exitMenu: function (el, ev) {
            //console.log('exitMenu');

            var toElement = $(ev.relatedTarget);
            if (toElement.is('.sub-menu')) {
                return false;
            }

            return true;
        },
        submenuDirection: 'below',
    });

    $('.sub-menu').on('mouseleave', function (e) {
        var toElement = $(e.toElement);
        var isMenuLink = toElement.is('.js-former-main-menu li a');
        var hasSameId = toElement.attr('data-id') == $(this).attr('data-id');

        if ((!isMenuLink || !hasSameId) && !$(this).hasClass('active')) {
            $(this).fadeOut(200);
            $('.js-former-main-menu ul').trigger('mouseleave');
        }
    });

    $('.js-mega-menu-dropdown').on('mouseover', function (e) {
        setHeaderColorToWhite()
    });

    $('.js-mega-menu-dropdown').on('mouseleave', function (e) {
        setInitialHeaderColor();
    });

    function setHeaderColorToWhite() {
        $('header').css({ backgroundColor: 'white' });
    } 

    function setInitialHeaderColor() {
        var headerColor = 'white';
        var heroColor = $('*[data-hero-color]').first().data("heroColor");
        if (heroColor && heroColor !== "#0B2A2D") { // exlude primary green
            headerColor = heroColor
        }
        $('header').css({ backgroundColor: headerColor });
    } 
    setInitialHeaderColor();

    $('.knowledge-filter-item').on('click', function () {
        var type = $(this).attr('data-type');

        $('.knowledge-filter-item').removeClass('active');
        $(this).addClass('active');

        if (type != 'all') {
            $('.blog-entry')
                .not('.' + type)
                .parent()
                .fadeOut(200);
            $('.blog-entry.' + type)
                .parent()
                .fadeIn(200);
        } else {
            $('.blog-entry').parent().fadeIn(200);
        }
    });

    $('.whitepaper-form-section .button').on('click', function (e) {
        e.preventDefault();

        $('.whitepaper-form-section form').fadeOut(200, function () {
            $('.whitepaper-form-section .whitepaper-thanks').fadeIn(200);
        });
    });

    // $('.product-menu .product-menu-button').on('click', function (e) {
    //     if ($(this).hasClass('animating')) {
    //         return;
    //     }

    //     $(this).addClass('animating');
    //     var self = this;

    //     if ($('.product-menu').hasClass('active')) {
    //         $('.product-menu ul').transition({ height: '0px' }, 200, 'in-out', function () {
    //             $('.product-menu').removeClass('active');
    //             $(self).removeClass('animating');
    //         });
    //     }
    //     else {
    //         $('.product-menu ul').transition({ height: 'auto' }, 200, 'in-out', function () {
    //             $('.product-menu').addClass('active');
    //             $(self).removeClass('animating');
    //         });
    //     }
    // });

    $('#download-drivers-form').on('submit', function (e) {
        e.preventDefault();

        var url = $(this).find('[name=manufacturer]').val();

        window.open(url, '_blank');
    });

    $('.js-om-product-teaser-slideshow').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
    });

    $('.js-om-hero-slider').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
    });

    //$('.case-block__case-wrapper').each(function () {
    //    const carousel = $(this).find(".js-case-carousel");

    //    carousel.slick({
    //        dots: false,
    //        arrows: true,
    //        infinite: false,
    //        speed: 500,
    //        slidesToShow: 1,
    //        slidesToScroll: 1,
    //        variableWidth: false,
    //        adaptiveHeight: false,
    //    });
    //});


    $('.js-card-list-block-carousel').each(function () {
        const controls = $(this).find(".card-list-block__controls");
        const prevControl = controls.find(".js-card-list-block-carousel-prev");
        const nextControl = controls.find(".js-card-list-block-carousel-next");
        const carousel = $(this).find(".card-list-block__carousel");

        carousel.slick({
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            variableWidth: true,
            adaptiveHeight: true,
        });

        carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            const windowSize = Math.min(4, slick.slideCount);
            const slideCount = slick.slideCount;
            const direction = nextSlide - currentSlide;
            const lastSlideIndex = nextSlide + windowSize - 1;

            if (direction < 0) { //left
                if (nextSlide <= 0) {
                    prevControl.addClass("card-list-block__control-button--disabled");
                }
                if (lastSlideIndex < slideCount - 1) {
                    nextControl.removeClass("card-list-block__control-button--disabled");
                }
            }
            else { // right
                if (lastSlideIndex >= slideCount - 1) {
                    nextControl.addClass("card-list-block__control-button--disabled");
                }
                if (nextSlide > 0) {
                    prevControl.removeClass("card-list-block__control-button--disabled");
                }
            }
        });

        prevControl.on('click', function () {
            carousel.slick("prev");
        });

        nextControl.on('click', function () {
            carousel.slick("next");
        });
    })

    $('.js-article-quote-list-block-carousel').on('init', function (event, slick) {
        const width = $('.js-article-quote-list-block-progress-total').width();
        const newWidth = (1 / slick.slideCount) * width;
        $('.js-article-quote-list-block-progress-current').animate({ width: newWidth }, 500);
    });

    $('.js-article-quote-list-block-carousel').slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        adaptiveHeight: true,
    });

    $('.js-article-quote-list-block-carousel-prev').on('click', () => {
        $('.js-article-quote-list-block-carousel').slick("prev");
    });

    $('.js-article-quote-list-block-carousel-next').on('click', () => {
        $('.js-article-quote-list-block-carousel').slick("next");
    });

    $('.js-article-quote-list-block-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        const normalizedIndex = nextSlide + 1;
        const width = $('.js-article-quote-list-block-progress-total').width();
        const newWidth = (normalizedIndex / slick.slideCount) * width
        $('.js-article-quote-list-block-progress-current').animate({ width: newWidth }, 500);
    });

    $('.js-om-image-gallery-images').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
    });

    $('.js-om-image-gallery-thumbs').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 8,
        slidesToScroll: 8,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
        ],
    });
    $('.js-om-image-gallery-thumb-link').on('click', function (e) {
        e.preventDefault();
        $('.js-om-image-gallery-images').slick('slickGoTo', $(this).data('slide'));
    });

    $(function () {
        var pis = $('#product-information-selector');
        if (pis.length > 0) {
            pis
                .select2({
                    minimumResultsForSearch: Infinity,
                })
                .on('change', function () {
                    var val = $(this).val();
                    $('.product-information').removeClass('active');
                    $('.product-information[data-id=' + val + ']').addClass('active');
                });
        }

        $('select:not(.no-s2)').select2({
            minimumResultsForSearch: Infinity,
        });
    });

    // Set up a MutationObserver to monitor changes to the faq block accordion
    var observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
            if (mutation.attributeName === "class") {
                const isCollapsed = $(mutation.target).hasClass('collapsed');
                $(mutation.target).parent().toggleClass('collapsed', isCollapsed);
            }
        });
    });

    var targetNodes = document.querySelectorAll('.faq-block__accordion__item__btn');
    var config = { attributes: true };

    targetNodes.forEach(function (node) {
        observer.observe(node, config);
    });
})(jQuery);

var mapStyles = [
    {
        featureType: 'all',
        elementType: 'geometry',
        stylers: [{ visibility: 'simplified' }, { color: '#ffffff' }],
    },
    {
        featureType: 'administrative',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [{ visibility: 'simplified' }],
    },
    {
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
    },
    { featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
    { featureType: 'road', elementType: 'all', stylers: [{ visibility: 'off' }] },
    {
        featureType: 'transit',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
    },
    { featureType: 'water', elementType: 'all', stylers: [{ color: '#c12737' }] },
];

var defaultctr = null;
if (typeof google !== 'undefined') {
    defaultctr = new google.maps.LatLng(59.332867, 18.0645);
}

var map = new Vue({
    el: $('.map-section')[0],
    data: {
        map: null,
        markers: [],
        defaultCenter: defaultctr,
        selected: null,
        open: false,
        query: '',
        animateGps: false,
        offices: [],
    },
    computed: {
        showOffices: function () {
            return this.open;
        },

        officeList: function () {
            if (this.query.length > 0) {
                var self = this;

                var offices = this.offices.filter(function (office) {
                    return (
                        office.name.toLowerCase().indexOf(self.query.toLowerCase()) > -1
                    );
                });

                if (offices.length > 0) {
                    this.open = true;
                }

                return offices;
            }

            return this.offices;
        },

        hasGeolocation: function () {
            return !!navigator.geolocation;
        },
    },
    methods: {
        selectOffice: function (office) {
            this.selected = office;
            if (typeof google === 'undefined') {
                return;
            }
            var center = new google.maps.LatLng(
                office.position.lat,
                office.position.lng
            );
            this.map.panTo(center);

            for (var i = 0; i < this.markers.length; i++) {
                var marker = this.markers[i];

                if (marker.position.equals(center)) {
                    marker.setIcon('/Corporate/images/marker-large.png');
                } else {
                    marker.setIcon('/Corporate/images/marker.png');
                }
            }
        },
        resetOffice: function () {
            this.selected = null;
            this.query = '';
            this.open = false;

            this.map.panTo(this.defaultCenter);

            for (var i = 0; i < this.markers.length; i++) {
                var marker = this.markers[i];

                marker.setIcon('/Corporate/images/marker.png');
            }
        },
        findByGps: function () {
            var self = this;

            this.animateGps = true;

            navigator.geolocation.getCurrentPosition(
                function (position) {
                    self.animateGps = false;

                    var pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                        accuracy: position.coords.accuracy,
                    };

                    var min = 999999;
                    var selectedOffice = null;
                    for (var i = 0; i < self.offices.length; i++) {
                        var office = self.offices[i];

                        var distance = self.getDistanceBetweenCoordinates(
                            office.position,
                            pos
                        );

                        if (distance < min) {
                            selectedOffice = office;
                            min = distance;
                        }
                    }

                    self.selected = selectedOffice;
                },
                function () {
                    alert('Ett problem uppstod. Försök igen');
                },
                {
                    enableHighAccuracy: true,
                    maximumAge: 30000,
                    timeout: 27000,
                }
            );
        },
        getDistanceBetweenCoordinates: function (first, second) {
            var p = 0.017453292519943295;
            var c = Math.cos;
            var a =
                0.5 -
                c((second.lat - first.lat) * p) / 2 +
                (c(first.lat * p) *
                    c(second.lat * p) *
                    (1 - c((second.lng - first.lng) * p))) /
                2;

            return 12742000 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
        },
        fetchOffices: function () {
            var self = this;

            $.get('/api/offices/get-offices', function (data, status) {
                if (status === 'success') {
                    self.offices = data;

                    for (var i = 0; i < self.offices.length; i++) {
                        var office = self.offices[i];
                        if (typeof google === 'undefined') {
                            return;
                        }
                        var marker = new google.maps.Marker({
                            map: self.map,
                            position: new google.maps.LatLng(
                                office.position.lat,
                                office.position.lng
                            ),
                            icon: '/Corporate/images/marker.png',
                        });

                        self.markers.push(marker);
                    }
                }
            });
        },
    },
    mounted: function () {
        if (typeof google === 'undefined') {
            return;
        }
        this.map = new google.maps.Map(this.$refs.map, {
            center: this.defaultCenter,
            zoom: 5,
            styles: mapStyles,
            mapTypeControl: false,
            panControl: false,
            rotateControl: false,
            scaleControl: false,
            streetViewControl: false,
            zoomControl: false,
        });

        this.fetchOffices();
    },
});

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

// Throttle a function to be called only at most every threshold milliseconds
function throttle(fn, threshhold, scope) {
    threshhold = threshhold || 250;
    var last, deferTimer;
    return function () {
        var context = scope || this;

        var now = +new Date(),
            args = arguments;
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
            }, threshhold);
        } else {
            last = now;
            fn.apply(context, args);
        }
    };
}